/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLoopRight2 = createReactComponent(
  "arrow-loop-right-2",
  "IconArrowLoopRight2",
  [
    ["path", { d: "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13", key: "svg-0" }],
    ["path", { d: "M17 16l4 -4l-4 -4", key: "svg-1" }]
  ]
);

export { IconArrowLoopRight2 as default };
//# sourceMappingURL=IconArrowLoopRight2.js.map
